var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    stroke: "#ececec",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8334 7C12.8334 3.77834 10.2217 1.16667 7.00008 1.16667C3.77842 1.16667 1.16675 3.77834 1.16675 7C1.16675 10.2217 3.77842 12.8333 7.00008 12.8333C10.2217 12.8333 12.8334 10.2217 12.8334 7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50381 4.50455L8.01709 5.53959C8.08708 5.68367 8.27373 5.82187 8.43121 5.84834L9.36152 6.00418C9.95646 6.10415 10.0964 6.53934 9.66774 6.96865L8.94449 7.69788C8.822 7.82137 8.75492 8.05955 8.79284 8.2301L8.9999 9.13281C9.16321 9.84734 8.787 10.1237 8.15999 9.75031L7.288 9.22985C7.13052 9.13575 6.87097 9.13575 6.71057 9.22985L5.83858 9.75031C5.21448 10.1237 4.83536 9.8444 4.99867 9.13281L5.20573 8.2301C5.24365 8.05955 5.17657 7.82137 5.05408 7.69788L4.33083 6.96865C3.90504 6.53934 4.04211 6.10415 4.63705 6.00418L5.56736 5.84834C5.72193 5.82187 5.90857 5.68367 5.97856 5.53959L6.49184 4.50455C6.77181 3.94293 7.22676 3.94293 7.50381 4.50455Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon-star.9e80d45208c8266dabe731529eb788af.svg";
export { ForwardRef as ReactComponent };